import * as React from "react";
import { forwardRef } from "react";
const PhotosIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.5 6.735a2.25 2.25 0 0 1 2.25-2.25h16.5a2.25 2.25 0 0 1 2.25 2.25v12a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25v-12zM3 16.796v1.939a.75.75 0 0 0 .75.75h16.5a.75.75 0 0 0 .75-.75v-1.939l-2.689-2.689a1.5 1.5 0 0 0-2.121 0l-.879.879.97.97a.75.75 0 0 1-1.061 1.061l-5.159-5.159a1.5 1.5 0 0 0-2.121 0L3 16.796zm11.25-2.871-3.129-3.129a3 3 0 0 0-4.243 0L3 14.675v-7.94a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 .75.75v7.939l-1.629-1.629a3 3 0 0 0-4.243 0l-.879.879zm-1.125-4.939a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0z"
}));
const ForwardRef = forwardRef(PhotosIcon);
export default ForwardRef;